import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { activateRechargeDeviceretain } from "@/api/dataAll/deviceRetain";
import * as echarts from "echarts";
export default {
  name: "activateRetentionPay",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      tableData: [],
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      PrimitiveDy: [],
      intReq: [],
      screen: [],
      cellStylekeys: ["rem"]
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.kind = 1;
                _this.PrimitiveDy = [];

                _this.searchClickPoints(activateRechargeDeviceretain, 1);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      var res = {
        data: {
          activity_num: 0,
          data: {},
          avgData: {},
          other: {
            activity_num: {}
          }
        }
      };
      var retain_num = {};
      qres.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
        res.data.other.activityRecharge_num = _objectSpread(_objectSpread({}, res.data.other.activityRecharge_num), i.other.activityRecharge_num);
        res.data.activity_num = res.data.activity_num + Number(i.activity_num);
        retain_num = _objectSpread(_objectSpread({}, retain_num), i.retain_num);

        for (var k in i.avgData) {
          var nums = i.retain_num[i.searchdate.starttime][k] == '/' ? 0 : Number(i.retain_num[i.searchdate.starttime][k]);
          res.data.avgData[k] = !res.data.avgData[k] ? nums : res.data.avgData[k] + nums;
        }
      });

      for (var i in res.data.avgData) {
        res.data.avgData[i] = (res.data.activity_num ? (res.data.avgData[i] / res.data.activity_num * 100).toFixed(2) : 0) + '%';
      }

      this.dates = [];
      this.screen = [];
      this.series = [];
      this.tableData = [];

      for (var k in res.data.data) {
        this.dates.push(k);
        var d = {
          date: k,
          activity_num: res.data.other.activityRecharge_num[k]
        };
        var length = Object.keys(res.data.data[k]).length;
        var o = {
          name: k,
          type: "line",
          data: [],
          smooth: true
        };
        var DynamicList = [];

        for (var j in res.data.data[k]) {
          d["rem" + j] = this.zhuan([res.data.data[k][j]])[0];
          o.data.push(d["rem" + j]);

          if (length > DynamicList.length) {
            var a = j == 2 ? this.$t('nextDayPrefix') : j;
            DynamicList.push({
              label: a + this.$t('retentionSuffix'),
              prop: "rem" + j,
              tableText: j == 2 ? this.$t('rraSuffix') + j : this.$t('rrPrefix') + j,
              desc: j == 2 ? this.$t('nextDayPayActivateDeviceRetention') : ""
            });
          }
        }

        if (!this.screen.length) {
          this.screen = DynamicList.map(function (item) {
            return item.prop;
          });
          this.PrimitiveDy = DynamicList;
        }

        this.screenControls();
        this.series.push(o);
        this.tableData.push(d);
      } // 总计数据处理


      var total = {
        date: this.$t('weightedAverageRetention'),
        activity_num: res.data.activity_num
      };

      for (var _k in res.data.avgData) {
        total["rem" + _k] = this.zhuan([res.data.avgData[_k]])[0];
      }

      this.tableData.push(total);
      this.timeInterval();
      this.$nextTick(function () {
        _this2.getTableRight();
      });
      this.getechart();
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 50);
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("activateRetentionPayEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('activateDeviceRetentionRate')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          // 这里显示点击搜索的日期--图表的最上面
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.label;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('activateDeviceNum'),
        prop: "activity_num"
      }].concat(_toConsumableArray(this.Dynamic));
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.Dynamic.forEach(function (item) {
        data.forEach(function (i) {
          i[item.prop] = i[item.prop] + "%";
        });
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};